import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var storageKey = function storageKey(parentEventSessionUuid) {
  return "flexPassPicks:v1:".concat(parentEventSessionUuid);
};
/** Имя query-параметра для каждого выбранного дочернего мероприятия (повторяется). */


export var FLEX_PASS_PICK_QUERY_KEY = 'flexPick';
/** Query-параметр минимального числа пиков (согласован с пулом). */

export var FLEX_PASS_PICK_MIN_QUERY_KEY = 'flexPickMin';
/** Имя query для API схемы/цен FLEX_PASS (повторяется для каждого id). */

export var SELECTED_CHILD_IDS_API_KEY = 'selectedChildIds';
/** Сериализация params для axios: selectedChildIds=…&selectedChildIds=… */

export function flexPassApiParamsSerializer(params) {
  var sp = new URLSearchParams();

  var _loop = function _loop() {
    var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];

    if (value === undefined || value === null) {
      return "continue";
    }

    if (Array.isArray(value)) {
      value.forEach(function (v) {
        return sp.append(key, String(v));
      });
    } else {
      sp.append(key, String(value));
    }
  };

  for (var _i = 0, _Object$entries = Object.entries(params); _i < _Object$entries.length; _i++) {
    var _ret = _loop();

    if (_ret === "continue") continue;
  }

  return sp.toString();
}
export function buildFlexPassPicksSearchString(payload) {
  var sp = new URLSearchParams();

  var _iterator = _createForOfIteratorHelper(payload.childEventSessionIds),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var id = _step.value;
      sp.append(FLEX_PASS_PICK_QUERY_KEY, String(id));
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  sp.set(FLEX_PASS_PICK_MIN_QUERY_KEY, String(payload.consistPicksMin));
  return sp.toString();
}
export function readFlexPassPicksFromSearchParams(params) {
  var ids = params.getAll(FLEX_PASS_PICK_QUERY_KEY).map(function (id) {
    return Number(id);
  }).filter(function (id) {
    return Number.isFinite(id) && id > 0;
  });

  if (ids.length === 0) {
    return null;
  }

  var minRaw = params.get(FLEX_PASS_PICK_MIN_QUERY_KEY);
  var minParsed = minRaw != null && minRaw !== '' ? Number(minRaw) : NaN;
  return {
    childEventSessionIds: ids,
    consistPicksMin: Number.isFinite(minParsed) && minParsed >= 1 ? minParsed : 1
  };
}
/** Сначала query (если есть выбранные id), иначе sessionStorage. */

export function resolveFlexPassPicksForParent(parentEventSessionUuid, searchParams, eventConsistPicksMin) {
  var fromUrl = readFlexPassPicksFromSearchParams(searchParams);

  if (fromUrl != null && fromUrl.childEventSessionIds.length > 0) {
    var floor = Number(eventConsistPicksMin) || 1;
    return {
      childEventSessionIds: fromUrl.childEventSessionIds,
      consistPicksMin: Math.max(floor, fromUrl.consistPicksMin)
    };
  }

  return readFlexPassPicks(parentEventSessionUuid);
}
export function writeFlexPassPicks(parentEventSessionUuid, payload) {
  sessionStorage.setItem(storageKey(parentEventSessionUuid), JSON.stringify(payload));
}
export function readFlexPassPicks(parentEventSessionUuid) {
  try {
    var raw = sessionStorage.getItem(storageKey(parentEventSessionUuid));
    if (!raw) return null;
    var parsed = JSON.parse(raw);

    if (!Array.isArray(parsed.childEventSessionIds) || typeof parsed.consistPicksMin !== 'number') {
      return null;
    }

    return parsed;
  } catch (_unused) {
    return null;
  }
}
export function clearFlexPassPicks(parentEventSessionUuid) {
  sessionStorage.removeItem(storageKey(parentEventSessionUuid));
}